/**
 * Service Worker Registration
 *
 * Registers the service worker, periodically checks for updates,
 * and automatically reloads the page when a new version is activated.
 */

const SW_UPDATE_CHECK_INTERVAL = 2 * 60 * 1000; // Check for SW updates every 2 minutes

let refreshing = false;

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service workers are not supported in this browser.");
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        console.log("Service Worker registered successfully.");

        // Periodically check for service worker updates
        setInterval(() => {
          registration.update();
        }, SW_UPDATE_CHECK_INTERVAL);

        // When a new service worker is found installing
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New SW installed while an old one controls the page
              // The new SW will call skipWaiting() automatically
              console.log(
                "New service worker installed. Waiting for activation..."
              );
            }
          });
        });
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // When a new service worker takes control, reload the page
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      console.log("New service worker activated. Reloading page...");
      window.location.reload();
    });

    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "SW_ACTIVATED") {
        console.log("Received SW_ACTIVATED message from service worker.");
      }
    });
  });
}
